export const getUserType = (type) => {
  if (type === 'OWNER') return {rol: 'Propietario', color: 's-bg-blue'}
  if (type === 'ADMIN') return {rol: 'Administrador', color: 's-bg-blue'}
  if (type === 'PENDING') return {rol: 'Pendiente', color: 's-bg-blue-200'}
  if (type === 'GUEST') return {rol: 'Invitado', color: 's-bg-yellow'}
}
